/** @format */

import { Component, Input, type OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { HomrProduct3DImagery } from '@shared/data-access/interfaces';

@Component({
    selector: 'pdp-sketchfab-3d-imagery',
    templateUrl: './sketchfab-3d-imagery.component.html',
    styleUrls: ['./sketchfab-3d-imagery.component.scss'],
    standalone: false
})
export class Sketchfab3dImageryComponent implements OnInit {
	@Input() data: HomrProduct3DImagery[];

	homrSketchfabModel: string;
	homrSketchfabId: string;
	homrSketchfabSrc: SafeResourceUrl;

	constructor(private sanitizer: DomSanitizer) {}

	ngOnInit(): void {
		if (this.data && this.data.length > 0) {
			this.homrSketchfabModel = this.data[0].sketchfabModel;
			this.homrSketchfabId = this.data[0].sketchfabID;
			this.setSafeIFrameSrc();
		}
	}
	setSafeIFrameSrc(): void {
		const url = `https://sketchfab.com/models/${this.homrSketchfabId}/embed?autospin=1&autostart=1&camera=0&ui_animations=0&ui_infos=0&ui_inspector=0&ui_watermark_link=0&ui_watermark=0&ui_ar=0&ui_settings=0&ui_vr=0&ui_annotations=0`;
		this.homrSketchfabSrc = this.sanitizer.bypassSecurityTrustResourceUrl(url);
	}
}
